import ContentLayout from "@/components/layout/ContentLayout"
import PrivacyPolicyContent from "@/components/privacy-policy-content"
import { FC } from "react"

const PrivacyPolicy: FC = () => {
  return (
    <ContentLayout title={"Privacy Policy"}>
      <PrivacyPolicyContent />
    </ContentLayout>
  )
}

export default PrivacyPolicy
